<template>
    <div class="clearfix">
        <div class="header_wrapper hidden-xs-only">
            <h1 class="fl">
                <img src="../../../assets/img/logo1.png" alt="" />
            </h1>
            <ul class="fl nav clearfix">
                <li
                    class="item"
                    :class="{
                        'select-style': idx == switchType,
                    }"
                    @click="toggleTab(idx, item.titleUrl, item.titleName, item)"
                    v-for="(item, idx) in navList"
                    :key="idx"
                >
                    {{ item.titleName }}
                    <ul class="dropdown-menu">
                        <li
                            @click.stop="toggleTab(idx, i.titleUrl, i.titleName, i)"
                            v-for="(i, didx) in item.dropDownMenuList"
                            :key="didx"
                        >
                            {{ i.titleName }}
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
        <div class="hidden-sm-and-up header_phone">
            <div class="logo">贵阳卫健投</div>
            <el-dropdown trigger="click" class="drop_nav">
                <div class="nav_button">
                    <span class="nav_icon">&#xe607;</span>
                </div>
                <el-dropdown-menu
                    slot="dropdown"
                    class="layer"
                    style="width: 40%"
                >
                    <el-dropdown-item
                        v-for="(item, idx) in navList"
                        @click.native="
                            toggleTab(idx, item.titleUrl, item.titleName, item)
                        "
                        :key="idx+ 'b'"
                        v-text="item.titleName"
                        v-show="item.childType == 0"
                        style="text-align: center; position: relative;border-bottom:1px solid #EBEEF5"
                    ></el-dropdown-item>
                    <el-collapse
                        class="drop_layer"
                        v-for="(item, idx) in navList"
                        :key="idx+ 'a'"
                        v-show="item.childType == 1"
                        style="margin-left: 9%; position: relative"
                    >
                        <el-collapse-item :title="item.titleName" name="1">
                            <el-dropdown-item
                                v-text="i.titleName"
                                @click.native="toggleTab(idx, i.titleUrl, i.titleName, i)"
                                v-for="(i, didx) in item.dropDownMenuList"
                                :key="didx+ 'c'"
                            ></el-dropdown-item>
                        </el-collapse-item>
                    </el-collapse>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>

<script>
import { headerMenuIe } from '../../../api/common/common'
export default {
    mounted() {
      this.getHeaderMenuRt()
    },
    watch: {
        // 监听路由，路由跳转，通过路由来切换导航的active类
        $route: {
            handler: function (val, oldVal) {
                switch (val.path) {
                    case "/home":
                        this.switchType = 0;
                        break;
                    case "/synopsis":
                        this.switchType = 1;
                        break;
                    case "/organization":
                        this.switchType = 1;
                        break;
                    case "/leadertalk":
                        this.switchType = 1;
                        break;
                    case "/newsfeed":
                        this.switchType = 2;
                        break;
                    case "/projectgroup":
                        this.switchType = 2;
                        break;
                    case "/expand":
                        this.switchType = 3;
                        break;
                    case "/development":
                        this.switchType = 3;
                        break;
                    case "/cultureidea":
                        this.switchType = 4;
                        break;
                    case "/culturepeople":
                        this.switchType = 4;
                        break;
                    case "/cultureup":
                        this.switchType = 4;
                        break;
                    case "/partystyle":
                        this.switchType = 5;
                        break;
                    case "/partystudy":
                        this.switchType = 5;
                        break;
                    case "/partytheory":
                        this.switchType = 5;
                        break;
                    case "/appointment":
                        this.switchType = 6;
                        break;
                    case "/recruit":
                        this.switchType = 6;
                        break;
                    case "/contact":
                        this.switchType = 7;
                        break;
                    default:
                        break;
                }
            },
            deep: true,
            immediate: true,
        },
    },
    data() {
        return {
            navList: [],
            switchType: 0,
        };
    },
    methods: {
        // 获取菜单树
        getHeaderMenuRt() {
          headerMenuIe().then(res => {
            console.log(res)
            this.navList = res.data
            console.log(this.navList)
          })
        },
        jumpRouterMethods(pathName, titleName) {
            this.$router.push({
                path: pathName,
                query: {
                    titleName: titleName,
                },
            });
        },
        toggleTab(index, routerPath, name, obj) {
            this.switchType = index;
            this.jumpRouterMethods(routerPath, name)
        },
    },
};
</script>
<style>
.el-collapse-item__content {
    padding-bottom: 0 !important;
}
</style>
<style lang="scss" scoped>
@import "../../../assets/styles/mixin.scss";
/* move */
.header_phone {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999999;
    width: 100%;
    display: flex;
    align-items: center;
    height: px2rem(56);
    background-image: linear-gradient(to right, #f6fafd, #6aaef5);
    padding-left: px2rem(10);
    box-sizing: border-box;
    .logo {
        width: 80%;
        font-size: px2rem(20);
        margin-left: px2rem(4);
        color: rgba(0, 0, 0, 0.9);
    }

    .nav_button {
        width: 40px;
        height: px2rem(40);
        color: #fff;
        border-color: rgba(0, 0, 0, 0.1);
        border: 1px solid #ccc;
        border-radius: 8px;
        text-align: center;
        line-height: px2rem(40);

        .nav_icon {
            font-family: "iconfont";
            font-size: px2rem(26);
        }
    }
}

.drop_nav {
    display: block !important;
}

.layer {
    position: fixed !important;
    top: px2rem(43) !important;
    line-height: px2rem(43) !important;
    font-size: px2rem(14) !important;
}

.drop_layer {
    display: flex;
    justify-content: center;
    align-items: center;
}
/* pc */
.header_wrapper {
    line-height: 61px;
    height: 61px;
    background-color: #178ccf;
    color: #fff;
    // margin-bottom: 1px;
    h1 {
        display: flex;
        align-items: center;
        width: 80px;
        height: 61px;
        margin-left: 33px;
        margin-right: 194px;
        font-size: 22px;
        img {
            width: 170px;
            height: 57px;
        }
    }
    .nav {
        .item {
            position: relative;
            float: left;
            padding: 0 34px;
            top: -1px;
            font-size: 15px;
            cursor: pointer;
            .dropdown-menu {
                display: none;
                position: absolute;
                left: 0;
                z-index: 999;
                width: 100%;
                background-color: #178ccf;
                color: #fff;
                li {
                    height: 61px;
                    width: 100%;
                    text-align: center;
                    line-height: 61px;
                }
            }
        }
        .select-style {
            background-color: #fff;
            color: #178ccf;
            // border-bottom: 1px solid #ccc;
        }
        :hover {
            background-color: #fff;
            color: #178ccf;
            .dropdown-menu {
                display: block;
                border: none;
                border: 1px solid #178ccf;
                box-sizing: border-box;
            }
        }
    }
}
</style>
<style>
.el-collapse-item__content {
    padding-bottom: 0 !important;
}
.el-collapse {
  border-top: none;
}
</style>



// WEBPACK FOOTER //
// src/views/iframepage/components/Header.vue